import { useState } from "react";
import { mergeClasses } from "@fluentui/react-components";
import { ChevronDoubleRightRegular } from "@fluentui/react-icons";
import { useGroupedWorkspaceDashboardStyles } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.styles";
import { IWorkspaceGroupRowProps } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.types";
import { GroupWorkspaceTable } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupWorkspaceTable";

export const WorkspaceGroupRow = ({
  group,
}: IWorkspaceGroupRowProps): JSX.Element => {
  const styles = useGroupedWorkspaceDashboardStyles();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { group: groupInfo, workspaceRows } = group;
  const workspaceCount = workspaceRows.length;
  const groupBodyId = `portfolio-group-body-${groupInfo.id}`;

  return (
    <div className={styles.groupCard}>
      <button
        type="button"
        className={styles.groupHeaderButton}
        onClick={() => setIsExpanded((current) => !current)}
        aria-expanded={isExpanded}
        aria-controls={groupBodyId}
      >
        <span
          className={mergeClasses(
            styles.chevron,
            isExpanded && styles.chevronExpanded,
          )}
          aria-hidden="true"
        >
          <ChevronDoubleRightRegular />
        </span>
        <span className={styles.groupName}>{groupInfo.label}</span>
        <span className={styles.groupCountPill}>
          {`${workspaceCount} workspace${workspaceCount === 1 ? "" : "s"}`}
        </span>
      </button>

      {isExpanded && (
        <div id={groupBodyId} className={styles.groupBody}>
          <GroupWorkspaceTable workspaceRows={workspaceRows} />
        </div>
      )}
    </div>
  );
};
